import React, { FC } from 'react'
import ROUTES from '../../utils/routes'
import { LessonType } from '../../../types'
import { Checkbox } from '../../System'
import { formatVideoLength } from '../../utils/formatVideoLength'
import { StyledLessonMapItem } from '.'

type Props = {
  lesson: LessonType;
  courseSlug: string;
  setLessonComplete(lesson: LessonType): void;
}

const LessonMapItem: FC<Props> = ({ lesson, courseSlug, setLessonComplete }) => {
  return (
    <StyledLessonMapItem
      to={ROUTES.courses.lessonBySlug(courseSlug, lesson.slug)}
      exact
      activeClassName="active"
    >
      <div className="lesson-item-details-container">
        <div className="lesson-item-thumbnail">
          {lesson.thumbnail?.fileHttpLink && <img src={lesson.thumbnail?.fileHttpLink} alt="" />}
        </div>
        <div className="lesson-item-details">
          <span className="lesson-item-title">{lesson.title}</span>
          <span className="lesson-item-time">
            {lesson.label || 'Lesson'} ∙ {formatVideoLength(lesson.video?.duration || 0)}
          </span>
        </div>
      </div>
      <Checkbox
        onClick={(e) => e.preventDefault()}
        onChange={() => setLessonComplete(lesson)}
        isChecked={lesson.isCompleted}
        name={`${lesson.title}-completed`}
      />
    </StyledLessonMapItem>
  )
}

export default LessonMapItem
